module.exports = __webpack_public_path__ + "static/media/Walking.73a6a97a.png";